<template>
    <v-container fluid class="main-container container-fixed h-100 d-block pa-0">
        <div class="content-block">
            <HomeTitle v-model="room"></HomeTitle>
            <BottomSheet
                v-if="locations && locations.length > 5"
                ref="BottomSheet"
                :activeGroup="activeGroup"
                :locations="locations"
                :offset="1"
                @setRoom="setActiveGroup"
            ></BottomSheet>
            <v-layout row class="locations-group-row" v-dragscroll.x>
                <v-btn
                    v-if="locations && locations.length > 5"
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    :input-value="activeGroup > 0"
                    depressed
                    rounded
                    @click="openSheet"
                >
                    {{activeGroup > 0 ? locations[activeGroup] : "Выберите комнату"}}
                    <div
                        v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                        class="size-20 ml-2"
                    />
                </v-btn>
                <v-btn
                    class="locations-group__btn mx-1"
                    active-class="locations-group__btn-active"
                    v-for="(location, index) in locationsScroll"
                    :key="index"
                    :input-value="activeGroup == index"
                    depressed
                    rounded
                    :id="`location${index}`"
                    @click="setActiveGroup(index)"
                >
                    {{ location }}
                </v-btn>
            </v-layout>
            <v-layout
                id="scroll-target"
                class="devices-list scroll-layout px-6 mt-6"
                column
                v-scroll:#scroll-target="onScroll"
            >
                <div v-if="scenariosFiltered.length == 0 && activeGroup == 0" class="img-center">
                    <v-flex text-center>
                        <div
                            v-html="require('!html-loader!@/assets/images/empty-device-list.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="main-text text-center">
                            Вы пока не добавили ни одного <br> сценария в избранное
                        </div>
                    </v-flex>
                </div>
                <div v-else :key="scenariosFiltered.length">
                    <div v-for="(group, index) in groupsFiltered" :key="'group' + index">
                        <ScenarioGroup :group="group" :showLocation="activeGroup === 0" :available="available"/>
                    </div>
                    <div v-for="(scenario, index) in scenariosFiltered" :key="'scenario' + index">
                        <ScenarioSwitch :scenario="scenario" :showLocation="activeGroup === 0" :available="available"/>
                    </div>
                </div>
            </v-layout>
        </div>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
    </v-container>
</template>

<script>
import HomeTitle from "../components/HomeTitle";
import BottomSheet from "@/components/BottomSheet.vue";
import ScenarioSwitch from "@/components/scenarios/ScenarioSwitch";
import ScenarioGroup from "@/components/scenarios/ScenarioGroup";
import ModalWaiting from "@/components/modals/ModalWaiting";
import { dragscroll } from 'vue-dragscroll';
import {eventBus} from "@/main";

export default {
    name: "ScenariosPage",
    directives: {
        dragscroll: dragscroll,
    },
    components: {
        HomeTitle,
        BottomSheet,
        ScenarioSwitch,
        ScenarioGroup,
        ModalWaiting,
    },
    data() {
        return {
            categories: [ "Все" ],
            locations: [],
            activeGroup: 1,
            scenarios: [],
            groups: [],
            available: [],
            room: null,
            openModalWaiting: false,
        };
    },
    created() {
        eventBus.$on("scenarioGroup", this.updateScenariosGroup);
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("scenarioGroup", this.updateScenariosGroup);
        eventBus.$off("reconnect", this.loadPage);
    },
    computed: {
        scenariosFiltered() {
            if (this.activeGroup > 0) {
                return this.scenarios.filter((el) => { return el.location == this.locations[this.activeGroup] });
            }
            return this.scenarios;
        },
        groupsFiltered() {
            if (this.activeGroup > 0) {
                return this.groups.filter((el) => { return el.location == this.locations[this.activeGroup] });
            }
            return this.groups;
        },
        locationsScroll() {
            if (this.locations && this.locations.length < 7) {
                return this.locations;
            }
            return this.categories;
        },
    },
    watch: {
        room(val) {
            if (val) {
                this.getScenarios();
                localStorage.RobohomeTZ = val.timezone;
            }
        },
    },
    methods: {
        getScenarios() {
            this.locations = [];
            this.scenarios = [];
            this.groups = [];
            this.openModalWaiting = true;
            this.$http.get('/scenarios/home/scenarios-list/' + this.room.uid + '/')
                .then((response) => {
                    this.locations = JSON.parse(JSON.stringify(this.categories));
                    if (response.data.locations) {
                        response.data.locations.forEach((el) => {
                            if (el) {
                                this.locations.push(el);
                            }
                        });
                    }
                    this.groups = response.data.groups;
                    this.scenarios = response.data.scenarios;
                    if (this.scenarios.filter((el) => { return el.is_favorite == true }).length == 0) {
                        this.activeGroup = 1;
                    }
                    this.available = response.data.available_conditions_and_actions;
                })
                .finally(() => {
                    this.$nextTick(() => {
                        if (this.$store.state.storeActiveGroup !== null) {
                            let i = this.locations.indexOf(this.$store.state.storeActiveGroup);
                            if (i !== -1) {
                                this.activeGroup = i;
                            }
                        }
                    });
                    this.openModalWaiting = false;
                });
        },
        setFavorite(item) {
            this.$http.put('/scenarios/home/scenarios/favorites/' + item.uid + '/', {
                is_favorite: !item.is_favorite,
            })
                .then(() => {
                    item.is_favorite = !item.is_favorite;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        onScroll(e) {
            this.offsetTop = e.target.scrollTop;
            this.$store.commit('setScroll', this.offsetTop);
        },
        setActiveGroup(index) {
            this.activeGroup = index;
            this.$store.commit("setActiveGroup", this.locations[this.activeGroup]);
        },
        openSheet() {
            this.$refs.BottomSheet.open();
        },
        updateScenariosGroup(data) {
            let groupChanged = this.groups.filter((el) => { return el.uid == data.group.uid })[0];
            let groupIndex = this.groups.indexOf(groupChanged);
            this.$set(this.groups, groupIndex, data.group);
        },
    },
}
</script>

<style lang="scss">
.main-container .devices-list.scroll-layout {
    height: calc(100% - 98px) !important;

    .img-center {
        position: relative;
        top: calc(50% - 98px) !important;
    }
}
</style>